export default "/images/vendor/flag-icons/flags/4x3/cc.svg?ee9a455c6bd419d93b8d468c74223943";